import { useMutation } from '@tanstack/react-query';
import { navigateNext, navigateBack } from '@services/navigationService';
import type { NavigationStep, NavigationResponse } from '@services/navigationService';

export const useSessionNavigation = (sessionId: string) => {
  const nextMutation = useMutation<NavigationResponse, Error, NavigationStep>({
    mutationFn: (step) => navigateNext(sessionId, step),
  });

  const backMutation = useMutation<NavigationResponse, Error, NavigationStep>({
    mutationFn: (step) => navigateBack(sessionId, step),
  });

  return {
    goToStep: nextMutation.mutateAsync,
    goToStepSync: nextMutation.mutate,
    goBackToStep: backMutation.mutateAsync,
    goBackToStepSync: backMutation.mutate,
    isPending: nextMutation.isPending || backMutation.isPending,
    isNextPending: nextMutation.isPending,
    isBackPending: backMutation.isPending,
    nextResult: nextMutation.data ?? null,
    nextError: nextMutation.error,
    resetNext: nextMutation.reset,
  };
};
